<div class="content-container" *ngIf="errorType">
  <div class="not-found-body">
    <img [src]="'../../assets/images/' + info[errorType].image" alt="image">
    <span class="title">{{info[errorType].title}}</span>
    <span class="subtitle">{{info[errorType].subtitle}}</span>
    <a class="link" [routerLink]="['/dashboard']">Take me back to the dashboard</a>
  </div>
</div>
